/*
 * @Descripttion:
 * @version: v1
 * @Author: liukx
 * @Date: 2022-05-05 20:23:32
 * @LastEditors: ???
 * @LastEditTime: 2022-05-14 14:30:24
 */
import { asyncRouterMap, constantRouterMap } from '@/router';

/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some((role) => route.meta.roles.includes(role));
  } else {
    return true;
  }
}
function treeToArr(data) {
  const result = [];
  data.forEach((item) => {
    const loop = (data) => {
      result.push(data);
      let child = data.childers;
      if (child) {
        for (let i = 0; i < child.length; i++) {
          loop(child[i]);
        }
      }
    };
    loop(item);
  });
  return result;
}

function hasRouter(routeData, route) {
  let arr = treeToArr(routeData);
  return arr.some(
    (item) => item.url === route.path || item.url === route.path.substr(1)
  ); //后台数据库忘记加/了  - -
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param routes asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(routes, roles) {
  const res = [];

  routes.forEach((route) => {
    const tmp = { ...route };
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRouter(tmp.children, roles);
      }
      res.push(tmp);
    }
  });

  return res;
}

function filtRouters(routes, routeData) {
  const res = [];

  routes.forEach((route) => {
    const tmp = { ...route };
    if (hasRouter(routeData, tmp) || tmp.hidden) {
      if (tmp.children) {
        tmp.children = filtRouters(tmp.children, routeData);
      }
      res.push(tmp);
    }
  });

  return res;
}

const permission = {
  state: {
    routers: [],
    addRouters: [],
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    },
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise((resolve) => {
        const { routeData } = data;
        let accessedRouters;
        accessedRouters = filtRouters(asyncRouterMap, routeData);
        // if (roles.includes('admin')) {
        //   accessedRouters = asyncRouterMap
        // } else {
        //   accessedRouters = filterAsyncRouter(asyncRouterMap, roles)
        // }
        commit('SET_ROUTERS', accessedRouters);
        resolve();

        // const { roles } = data
        // let accessedRouters
        // if (roles.includes('admin')) {
        //   accessedRouters = asyncRouterMap
        // } else {
        //   accessedRouters = filterAsyncRouter(asyncRouterMap, roles)
        // }
        // commit('SET_ROUTERS', accessedRouters)
        // resolve()
      });
    },
  },
};

export default permission;
